var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.bluredBtn),expression:"bluredBtn"}],staticClass:"relative Dropdown-onFocus",class:[
    {'focused' : _vm.dropdownIsActive},
    _vm.containerClasses ]},[_vm._t("button",null,{"events":{ atClick: _vm.openDropdown }}),_vm._v(" "),_c('div',{staticClass:"\n      Dropdown-content absolute z-20 bg-white text-gray-default rounded shadow-dropdown overflow-y-auto whitespace-nowrap flex flex-col\n    ",class:[
      _vm.contentClasses,
      _vm.openDropdownPosition,
      _vm.takesFullWidth ? 'w-full' : 'w-auto'
    ]},[_vm._t("content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }